import { useState } from "react";
import { Plus, Minus } from "lucide-react";

export const AccordionList = ({ items, testPrefix }) => {
  const [open, setOpen] = useState(0);
  return (
    <div className="border-t border-black/10">
      {items.map((item, i) => (
        <div key={i} className="border-b border-black/10">
          <button
            data-testid={`${testPrefix}-trigger-${i}`}
            onClick={() => setOpen(open === i ? -1 : i)}
            className="w-full flex items-center gap-5 py-6 text-left group"
          >
            <span className="font-mono-c text-[13px]" style={{ color: "#6D28D9" }}>
              {String(i + 1).padStart(2, "0")}
            </span>
            <span className="font-display font-semibold uppercase tracking-tight text-base md:text-lg flex-1 group-hover:text-black transition-colors duration-200 text-[#181818]">
              {item.title}
            </span>
            {open === i ? <Minus size={18} className="text-black/40" /> : <Plus size={18} className="text-black/40" />}
          </button>
          <div
            className="overflow-hidden transition-[max-height,opacity] duration-400 ease-out"
            style={{ maxHeight: open === i ? 200 : 0, opacity: open === i ? 1 : 0 }}
          >
            <p className="pb-6 pl-10 pr-8 text-[15px] leading-relaxed text-black/55 max-w-2xl" data-testid={`${testPrefix}-content-${i}`}>
              {item.body}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};
